const modifyExternalUrl = url => (url || '').split('!-#@')[0];

export default modifyExternalUrl;
